export default {
  functional: true,
  name: 'PageBoolean',
  props: ['value'],
  render (h, context) {
    return context.props.value
      ? (
        <v-icon small>mdi-check</v-icon>
      ) : (
        <v-icon small>mdi-close</v-icon>
      )
  }
}
